import React, {useEffect, useState} from 'react'
import './CompanyArea.scss'
import {useHistory} from "react-router-dom";
import AddIcon from "@material-ui/icons/Add";
import EditIcon from "@material-ui/icons/Edit";
import {useDispatch, useSelector} from 'react-redux';
import {selectUid} from '../../../slices/auth';
import {EditCompanyArea, EditRmInfo} from '../../CompanyComponents';
import {openDialog} from '../../../slices/dialog';
import {deleteFile} from '../../../api/common';
import {Collections} from '../../../api/collections';
import ButtonCircle from '../../Common/ButtonCircle';
import {storeSelectedArea, storeSelectedRmId} from '../../../slices/selected';
import Button from '../../Common/Button';
import DeleteIcon from "@material-ui/icons/Delete";
import {selectMacroareas, selectRole, selectUser} from '../../../slices/profile';
import {useTranslation} from 'react-i18next';
import {ROUTES} from '../../../db/models/const';

const CompanyArea = ({area, companyId}) => {
    const dispatch = useDispatch();
    const uid = useSelector(selectUid);
    const user = useSelector(selectUser);
    const role = useSelector(selectRole);
    const editable = role === "company";
    const history = useHistory();
    const macroareas = useSelector(selectMacroareas);
    const [macroareaName, setMacroareaName] = useState("");
    const {t} = useTranslation();
    const [showRms, setShowRms] = useState(false);

    const onAddRm = (areaId) => {
        dispatch(openDialog({
            Content: EditRmInfo,
            props: {
                areaId
            },
            title: t("company_addRm_title"),
            closable: true
        }));
    };

    const onEditArea = area => {
        dispatch(openDialog({
            Content: EditCompanyArea,
            title: "Area",
            closable: true,
            props: {
                area
            }
        }));
    }

    const countAreaFollowers = area => {
        return Object.values(area?.rms || {}).map(rm => rm.followerCount || 0).reduce((a, b) => a + b, 0);
    }

    const onRmClick = (area, rmId) => {
        dispatch(storeSelectedRmId({rmId}));
        dispatch(storeSelectedArea({area}));
        if (role === "student") history.push(ROUTES.STUDENT_RM.replace(":rmId", rmId));
        if (role === "company") history.push(ROUTES.COMPANY_RM);
    }

    const onFileDelete = () => {
        deleteFile(`${uid}/areas/${area.id}/image`, `image`, `${Collections.COMPANY_AREAS}/${area.id}`);
    };

    useEffect(() => {
        const macroareaId = area?.macroareaId || "";
        const found = macroareas.find(macro => macro.id === macroareaId);

        if (found) setMacroareaName("#" + found.name);

    }, [area, macroareas])

    useEffect(() => {
        if (!user || !area) return;

        let showRms = false;
        if (user.id === area.companyId) showRms = true;
        else {
            if (area?.demo) {
                if (user?.demo) showRms = true;
                else showRms = false;
            } else {
                showRms = true;
            }
        }
        setShowRms(showRms);
    }, [user, area]);

    return (
        <div key={area.id} className="card cardArea">
            {macroareaName && <span>{macroareaName}</span>}
            <div className="card__header">
                <div className="card__headerTitle shorten-1">
                    {area.name}
                </div>
                {role === "company" &&
                    <div className="card__headerAction">
                        <ButtonCircle onClick={() => onEditArea(area)}><EditIcon/></ButtonCircle>
                    </div>
                }
            </div>
            <div className="card__content">
                {area.description && <div className="text" dangerouslySetInnerHTML={{__html: area.description ?? ""}} />}
                <div className="card__kpi">
                    <p className="chip">{t("company_vivaio_area_students", {count: countAreaFollowers(area) || 0})}</p>
                    <p className="chip">{t("company_vivaio_area_paths", {count: Object.values(area?.rms || {}).length})}</p>
                </div>
                {/* {area?.image && <div className="card__image" style={{ backgroundImage: `url(${area?.image})` || null }} />} */}
                {area?.image && <div className="card__imageWrapper">
                    <div className="card__image" alt='' style={{backgroundImage: `url(${area?.image})` || null}}>
                        <div className="card__empty"></div>
                        {editable && <ButtonCircle onClick={() => onFileDelete()}><DeleteIcon/></ButtonCircle>}
                    </div>
                </div>}
                {/* {area?.videoUrl && (
                    <>
                        <video width="100%" controls>
                            <source src={area.videoUrl} type="video/mp4" />
                        </video>
                        <button onClick={() => onVideoDelete(area.id)}>Cancella video</button>
                    </>
                )} */}
            </div>
            <hr/>
            <div className="card__rms">
                <p className="card__rmsTitle">{t("company_vivaio_path_title")}</p>
                <div className="card__rmsItems">
                    {showRms && Object.values(area?.rms || {}).map(rm =>
                        <div className="rm no-overflow" id="cardArea__rmButton" key={rm.id}
                             onClick={() => onRmClick(area, rm.id)}>{rm.name}</div>
                    )}
                    {role === "company" &&
                        <Button onClick={() => onAddRm(area.id)}>
                            <AddIcon/>
                            <div className="text">{t("company_vivaio_addPathBtn")}</div>
                        </Button>
                    }
                </div>
            </div>
            {/* <div className="card__footer">
                {role === "company" &&
                    <div className="card__footerActions">
                        <IconButton onClick={() => onEditArea(area)}>
                            <EditIcon />
                        </IconButton>
                    </div>
                }
            </div> */}
        </div>
    )
}

export default CompanyArea
